<title>{{title}}</title>

<div [ngClass]="{ 'dx-rtl': rtlEnabled }">

<router-outlet   ></router-outlet>
</div>
<app-error-fire-ui></app-error-fire-ui>
<app-loaderspin></app-loaderspin>
<app-confirmdialog></app-confirmdialog>
